import { AlertCircle } from 'lucide-react';
import { MoveInAppointmentBookingFlowProps } from './MoveInAppointmentBookingFlow';
import { MoveInConfirmedCard } from './MoveInAppointmentCards';
import { Johnson390MoveInSlotPicker } from './Johnson390MoveInSlotPicker';

export type Johnson390MoveInAppointmentBookingProps = MoveInAppointmentBookingFlowProps;

export function Johnson390MoveInAppointmentBooking({
  mode,
  bookingError,
  scheduledDate,
  appointmentStartTime,
  appointmentEndTime,
  isByTheBed = false,
  lease,
  booking,
  calendarLoading,
  dateWindow,
  slotsByDate,
  canGoBack,
  canGoForward,
  blockedDates,
  todayET,
  rescheduleAvailable = true,
  onReschedule,
  onBook,
  onPrevWeek,
  onNextWeek,
}: Johnson390MoveInAppointmentBookingProps) {
  const showPicker =
    scheduledDate != null && (mode === 'pending-confirm' || mode === 'picker');

  return (
    <div className="space-y-5">
      {bookingError && (
        <div className="flex items-start gap-2 p-3 bg-red-50 dark:bg-red-950/40 border border-red-100 dark:border-red-900/40 rounded-lg">
          <AlertCircle size={16} className="text-red-600 dark:text-red-400 mt-0.5 shrink-0" />
          <p className="text-sm text-red-700 dark:text-red-400">{bookingError}</p>
        </div>
      )}

      {mode === 'confirmed' && appointmentStartTime && appointmentEndTime && (
        <MoveInConfirmedCard
          startTime={appointmentStartTime}
          endTime={appointmentEndTime}
          onReschedule={onReschedule}
          lease={lease}
          rescheduleAvailable={rescheduleAvailable}
        />
      )}

      {showPicker && (
        <Johnson390MoveInSlotPicker
          scheduledDate={scheduledDate}
          appointmentStartTime={appointmentStartTime}
          appointmentEndTime={appointmentEndTime}
          isByTheBed={isByTheBed}
          dateWindow={dateWindow}
          slotsByDate={slotsByDate}
          loading={calendarLoading}
          booking={booking}
          todayET={todayET}
          blockedDates={blockedDates}
          canGoBack={canGoBack}
          canGoForward={canGoForward}
          onBook={onBook}
          onPrevWeek={onPrevWeek}
          onNextWeek={onNextWeek}
        />
      )}
    </div>
  );
}
